import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const AccountIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.accountIcon}`}
        data-testid={testId}
        fill='none'
        height='28'
        viewBox='0 0 22 22'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M11 0.400391C16.8449 0.400391 21.5996 5.15506 21.5996 11C21.5995 16.8448 16.8449 21.5996 11 21.5996C5.15513 21.5996 0.400496 16.8448 0.400391 11C0.400391 5.15506 5.15507 0.400391 11 0.400391ZM11 16.6309C9.00813 16.6309 7.08124 17.2743 5.49121 18.4512C7.03317 19.5941 8.93785 20.2734 11 20.2734C13.0616 20.2734 14.9654 19.5935 16.5068 18.4512C14.917 17.2748 12.9914 16.6309 11 16.6309ZM10.9629 1.72656C5.8664 1.74664 1.72656 5.89889 1.72656 11C1.72665 13.3907 2.6356 15.5725 4.12695 17.2188L4.43359 17.54L4.43555 17.543C4.43987 17.5477 4.44289 17.551 4.44922 17.5576L4.45996 17.5674C6.32209 16.105 8.62123 15.3048 11 15.3047C13.3785 15.3047 15.677 16.1055 17.5391 17.5674C17.542 17.5645 17.5458 17.5626 17.5488 17.5596L17.5762 17.5322C19.2428 15.8547 20.2734 13.5456 20.2734 11C20.2734 5.88651 16.1135 1.72656 11 1.72656H10.9629ZM11 5.91992C13.4292 5.92003 15.4053 7.89598 15.4053 10.3252C15.405 12.7542 13.429 14.7304 11 14.7305C8.57096 14.7303 6.595 12.7541 6.59473 10.3252C6.59473 7.8962 8.57079 5.92006 11 5.91992ZM11 7.24609C9.30245 7.24624 7.9209 8.62741 7.9209 10.3252C7.92117 12.0228 9.30262 13.4042 11 13.4043C12.6974 13.4042 14.0788 12.0228 14.0791 10.3252C14.0791 8.62739 12.6975 7.2462 11 7.24609Z'
            fill='currentColor'
        />
    </svg>
);

export default AccountIcon;
